/**
 * El indicador de carga de Pamesa: el trazo de la P del logotipo, dibujándose.
 *
 * Portado del `loader.js` del motor de similitud de imágenes, que es DOM imperativo
 * —`createElement`, `appendChild`, una instancia global reutilizada—. Aquí eso sería
 * un cuerpo extraño: React ya sabe cuándo algo está cargando, así que lo que se trae
 * es lo único que no se puede rehacer, el trazado, y el resto lo pone el marco.
 *
 * El `pathLength="1"` normaliza la longitud del trazo a 1, de modo que la animación
 * se escribe en fracciones y no en las unidades del `viewBox`. Sin eso habría que
 * medir el camino en JavaScript para saber cuánto vale un «medio dibujado».
 */

/** Trazo central del logotipo, del contorno oficial. viewBox 865×1070. */
const PATH_D =
  "M 195 184 L 195 1167 L 197 1169 L 494 1169 L 496 1167 L 496 451 L 586 450 " +
  "L 604 455 L 620 464 L 635 478 L 645 493 L 650 505 L 654 524 L 653 551 L 646 573 " +
  "L 634 591 L 615 607 L 594 616 L 584 618 L 545 618 L 543 620 L 543 879 L 545 881 " +
  "L 637 882 L 678 878 L 718 869 L 754 856 L 787 840 L 822 818 L 846 799 L 876 770 " +
  "L 903 737 L 924 704 L 942 667 L 954 634 L 963 598 L 968 563 L 969 516 L 964 472 " +
  "L 955 434 L 940 393 L 921 356 L 899 323 L 872 291 L 832 255 L 795 230 L 764 214 " +
  "L 722 198 L 674 187 L 634 183 L 197 183 Z";

export function PamesaLoader({
  size,
  label = "Cargando",
  className,
}: {
  /** Cualquier medida CSS. Por defecto la del componente, 72px. */
  size?: string;
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={`pl${className ? ` ${className}` : ""}`}
      style={size ? ({ "--pl-size": size } as React.CSSProperties) : undefined}
    >
      <svg className="pl__svg" viewBox="150 140 865 1070" role="img" aria-label={label}>
        <path className="pl__path" pathLength={1} d={PATH_D} />
      </svg>
    </span>
  );
}

/**
 * Pantalla de carga completa. `role="status"` y no `alert`: es información de
 * progreso, no algo que deba interrumpir a quien use lector de pantalla.
 */
export function PamesaSplash({ message }: { message?: string }) {
  return (
    <div className="pl-full" role="status" aria-live="polite">
      <PamesaLoader size="96px" label={message ?? "Cargando"} />
      {message && <p className="pl-full__msg">{message}</p>}
    </div>
  );
}
